<template>
  <section class="chat-panel">
    <div class="top">
      <div>
        <h3>游戏内与 AI 交流</h3>
        <p class="muted">安装客户端 MOD 后，联机玩家可以按 F8 向唯一的 AI 伙伴发送消息；回复会通过游戏聊天栏送回原玩家。</p>
      </div>
      <el-button size="small" :loading="loading" @click="refresh">刷新记录</el-button>
    </div>
    <div class="steps">
      <div><strong>① 下载轻量启动器</strong><p>解压打开即可使用。首次会自动识别游戏目录，找不到时选择一次。</p></div>
      <div><strong>② 一键开始游戏</strong><p>自动检查 AI MOD、按需安装 SMAPI，并通过 SMAPI 启动游戏。</p></div>
      <div><strong>③ 加入农场按 F8</strong><p>输入想对伙伴说的话并确认，回复会出现在聊天消息中，按 T 查看。</p></div>
    </div>
    <a class="download" href="/downloads/launcher/StardewAI-Launcher-v1.0.1.zip" download>
      ⬇ 下载 Windows 一键联机启动器（推荐）
    </a>
    <p class="muted small">已有 SMAPI 的玩家，也可以<a href="/downloads/launcher/stardew-ai-mod-0.3.1.zip" download>手动下载 MOD</a>。启动器不会删除其他 MOD 或存档。</p>
    <p class="muted small">这不是 AI NPC 实体：目前实现的是玩家主动对话，尚未实现游戏地图中的独立角色和自主行动。</p>
    <div class="history-head">
      <strong>最近游戏内对话</strong><span class="muted">{{ loading?'正在读取…':'每 15 秒检查一次' }}</span>
    </div>
    <div v-if="error" class="error">{{ error }}</div>
    <div v-if="!records.length" class="empty">暂无游戏内对话。安装客户端 MOD 并实际发消息后，会在这里看到收据。</div>
    <div v-for="record in records" :key="record.id" class="record">
      <div class="record-head">
        <strong>{{record.playerName||'游戏玩家'}}</strong>
        <el-tag :type="record.reply?'success':'warning'" size="small">
          {{record.reply?'已生成回复':'等待模型回复'}}
        </el-tag>
      </div>
      <p class="message">{{record.message}}</p>
      <p v-if="record.reply" class="answer">伙伴：{{record.reply}}</p>
      <div class="timestamp">{{ formatTime(record.receivedAt) }} · {{record.participantKey}}</div>
    </div>
    <p class="muted small">“已生成回复”表示服务器已保存 AI 回答，不代表已经被游戏客户端确认收到。相同消息编号会去重，断线后尝试重投递。</p>
  </section>
</template>
<script setup>
import {onMounted,onUnmounted,ref} from 'vue'
import {http} from '../plugins/axios'
const records=ref([]),loading=ref(false),error=ref('')
let timer
function formatTime(s){if(!s)return '未知时间';const x=new Date(s);return Number.isNaN(x.getTime())?'未知时间':x.toLocaleString('zh-CN',{hour12:false})}
async function refresh(){
  if(loading.value)return
  loading.value=true
  try{
    const result=await http.get('/api/manage/ai/game-chat',{params:{_t:Date.now()},timeout:10000})
    records.value=Array.isArray(result.data)?result.data:[]
    error.value=''
  }catch(e){error.value='暂时无法读取游戏内聊天记录，请检查后台或重新登录'}
  finally{loading.value=false}
}
onMounted(()=>{refresh();timer=setInterval(()=>{if(!document.hidden)refresh()},15000)})
onUnmounted(()=>clearInterval(timer))
</script>
<style scoped>
.chat-panel{padding:24px;border:1px solid #dce8dd;background:#fcfefa;border-radius:14px;margin-top:20px}
.top,.history-head,.record-head{display:flex;align-items:flex-start;justify-content:space-between;gap:12px}
h3{font-size:17px;color:#3d6145;margin:0}
.muted{color:#829185;font-size:13px;line-height:1.8;margin:6px 0 12px}
.small{font-size:12px}.steps{display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:12px;margin:16px 0}
.steps>div{padding:13px 14px;border-radius:10px;background:#f0f6ed}
.steps strong{font-size:13px;color:#3c6646}.steps p{font-size:12px;color:#6d846f;line-height:1.7;margin:7px 0 0}
.download{display:inline-block;background:#547a56;color:#fff;text-decoration:none;padding:10px 14px;border-radius:8px;font-size:13px;font-weight:600}
.history-head{margin:24px 0 12px;align-items:center}.history-head strong{font-size:14px}
.empty{padding:16px;background:#f7faf3;border-radius:9px;font-size:13px;color:#7d9181}
.record{border-top:1px solid #e3ebe2;padding:14px 0}.record-head strong{font-size:13px;color:#416548}
.message,.answer{white-space:pre-wrap;overflow-wrap:anywhere;line-height:1.8;font-size:13px}
.answer{color:#436c48;background:#f3f8ef;padding:9px;border-radius:7px}.timestamp{font-size:11px;color:#98a79a}
.error{font-size:13px;color:#b24c4c;padding:10px}
@media(max-width:650px){.steps{grid-template-columns:1fr}.chat-panel{padding:17px}.top{flex-wrap:wrap}}
</style>
